import React from 'react';
import AccordionReferralCard from 'components/card/AccordionReferralCard';
import DetailItem from 'components/card/ItemDetail';
import FileRow from 'components/file-components/file-row';
import { UserCard } from 'components/card/UserCard';
import { AssetSuspect, EntityType, Referral } from 'types';


interface SuspectCardProps {
  referralData?:Referral | null
  referralId?: string;
  handleButtonClick: (type: EntityType) => void;
  handleEdit: (type: EntityType, suspect: AssetSuspect) => void;
  handleDelete: (id: string, type: EntityType) => void;
  handleUserView: (user: any, title: string, description: string, children?: React.ReactNode) => void;
  fileRowProps: any;
}

export default function SuspectCard({
  referralData,
  referralId,
  handleButtonClick,
  handleEdit,
  handleDelete,
  handleUserView,
  fileRowProps
}: SuspectCardProps) {
  return (
    <AccordionReferralCard
      title={`Suspects - ${referralData?.suspects?.length || 0}`}
      buttonText="Add Suspect"
      onButtonClick={() => handleButtonClick("suspect")}
      disabled={
        !referralData ||
         [
          "Asset Recovery Requested",
          "Asset Recovery Request Approved",
          "Asset Recovery On Revision",
          "Asset Recovery Updated",
          "Asset Recovery On Litigation",
          "Asset Recovery Final Verdict",
          "Prohibition On litigation",
          "Prohibition Final Verdict",
        ].includes(referralData?.action_status as string)
      }
    >
      {referralData?.suspects && referralData.suspects.length > 0 ? (
        <div className="space-y-4 p-4">
          {referralData.suspects.map((suspect) => (
            <UserCard
              key={suspect.id}
              avatarUrl=""
              date={suspect?.court_appointment_date as string}
              name={suspect?.person?.full_name as string}
              role={suspect?.person?.region as string}
              time={""}
              onDelete={() => handleDelete(suspect?.id as string, "suspect")}
              onEdit={() => handleEdit("suspect", suspect)}
              user={suspect.person}
              title="Suspect Details"
              description="Detailed information about suspect"
              disabled={
                      ![
                        "Investigation Ongoing",
                        "Pending",
                        "Prohibition On Revision",
                      ].includes(referralData?.action_status as string)
                    }
              onView={() => handleUserView(
                suspect.person,
                "Suspect Details",
                "Detailed information about suspect",
                <div className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <DetailItem
                      label="Suspect Condition"
                      value={
                        suspect.suspect_condition
                          ? suspect.suspect_condition.replace(/_/g, " ")
                          : "Not specified"
                      }
                    />
                    {suspect.suspect_condition === "police_custody" &&
                      suspect.court_appointment_date && (
                        <DetailItem
                          label="Court Appointment Date"
                          value={suspect.court_appointment_date}
                        />
                      )}
                    {suspect.suspect_condition === "judicial_custody" &&
                      suspect.final_verdict_amount && (
                        <DetailItem
                          label="Final Verdict Amount"
                          value={suspect.final_verdict_amount}
                        />
                      )}
                    {suspect.suspect_condition === "not_in_custody" && (
                      <>
                        {suspect.not_in_custody_reason && (
                          <DetailItem
                            label="Not In Custody Reason"
                            value={suspect.not_in_custody_reason}
                          />
                        )}
                        {suspect.bail_information && (
                          <DetailItem
                            label="Bail Information"
                            value={suspect.bail_information.replace(/_/g, " ")}
                          />
                        )}
                      </>
                    )}
                    {suspect.bail_information === "court_bail" && (
                      <>
                        {suspect.court_registration_number && (
                          <DetailItem
                            label="Court Registration"
                            value={suspect.court_registration_number}
                          />
                        )}
                        {suspect.court_bail_amount && (
                          <DetailItem
                            label="Court Bail Amount"
                            value={suspect.court_bail_amount}
                          />
                        )}
                      </>
                    )}
                    {suspect.bail_information === "police_bail" && (
                      <>
                        {suspect.incident_registration_number && (
                          <DetailItem
                            label="Incident Registration"
                            value={suspect.incident_registration_number}
                          />
                        )}
                        {suspect.police_bail_amount && (
                          <DetailItem
                            label="Police Bail Amount"
                            value={suspect.police_bail_amount}
                          />
                        )}
                      </>
                    )}
                  </div>
                  
                  {suspect.court_bail_evidence_details && suspect.court_bail_evidence_details.length > 0 && (
                    <div>
                      <h4 className="font-semibold text-gray-700 mb-2">
                        Court Bail Evidence:
                      </h4>
                      <div className="space-y-2">
                        {suspect.court_bail_evidence_details.map((file: any, index: number) => (
                          <FileRow
                            key={file.document_uuid || index}
                            file={file}
                            {...fileRowProps}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {suspect.police_bail_evidence_details && suspect.police_bail_evidence_details.length > 0 && (
                    <div>
                      <h4 className="font-semibold text-gray-700 mb-2">
                        Police Bail Evidence:
                      </h4>
                      <div className="space-y-2">
                        {suspect.police_bail_evidence_details.map((file: any, index: number) => (
                          <FileRow
                            key={file.document_uuid || index}
                            file={file}
                            {...fileRowProps}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            />
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500">
          No suspects added yet
        </div>
      )}
    </AccordionReferralCard>
  );
}